// Setting some constants for the app
const dictionary = () => ({
  protocol: {
    noProtocolName: "No protocol",
    noProtocolImage: "/assets/img/placeholder/protocol.png",
  },
  statsDefaultValue: -1000000,
  intercomButtonCaption: "Get help",
  superPools: {
    helpArticle: "https://help.superform.xyz/en/articles/9519396-superpools",
    registerHelpArticle: "https://help.superform.xyz/en/articles/9519441-registering-erc20-superpositions",
  },
  retain4626: {
    helpArticle: "https://help.superform.xyz/en/articles/10224080-what-is-a-multi-step-vault",
  },
  account: {
    descriptionFieldLimit: 1000,
  },
  stablecoinAssetPatterns: ["usd", "dai", "eur"],
});
export default dictionary();
